export type PlatformNavigator = {
  platform?: string;
  userAgentData?: { platform?: string };
};

export const isApplePlatform = (nav: PlatformNavigator): boolean =>
  /mac|iphone|ipad|ipod/i.test(
    nav.userAgentData?.platform ?? nav.platform ?? ''
  );
